import React, {ReactNode, useEffect, useMemo, useRef, useState} from 'react';
import {ITaskCreationSingleVoyageMutateVoyage} from "@containers/singleVoyage/mutateVoyage/tasks/types";
import {IRootContextMutateSingleVoyage} from "@containers/singleVoyage/mutateVoyage/context/rootContext/types";
import {IPositionSingleVoyage} from '@containers/singleVoyage/types/position';
import {IWayPointCreationWithCorrectionsSingleVoyage} from "@containers/singleVoyage/types/point";
import {IRouteInfoSingleVoyage} from '@containers/singleVoyage/types/route';
import {IRouteInfoMutateSingleVoyage} from "@containers/singleVoyage/mutateVoyage/types";
import {
	getInitialRouteInfoMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/route/helpers/getInitialRouteInfoMutateSingleVoyage";
import {
	useGetPointTemplateByIdsSingleVoyages
} from "@containers/singleVoyage/pointTemplates/hooks/useGetPointTemplateByIdsSingleVoyages";
import {useAccountIdSingleVoyage} from "@containers/singleVoyage/account/hooks/useAccountIdSingleVoyage";


export const MutateVoyageRootContext = React.createContext<IRootContextMutateSingleVoyage | null>(null)

interface IProps {
	children: ReactNode
	initialPositions?: IPositionSingleVoyage[]
	initialPoints?: IWayPointCreationWithCorrectionsSingleVoyage[]
	initialRouteInfo?: IRouteInfoSingleVoyage
	initialTasks?: ITaskCreationSingleVoyageMutateVoyage[]
	voyageId?: number
	initialTasksLocalCreateIds?: number[]
}

const RootContextProviderMutateSingleVoyage = ({
												   children,
												   initialPositions,
												   initialPoints,
												   initialRouteInfo,
												   voyageId,
												   initialTasks,
												   initialTasksLocalCreateIds,
											   }: IProps) => {

	const {accountId} = useAccountIdSingleVoyage()
	const [showAddPointIcon, setShowAddPointIcon] = useState<boolean>(false)
	const [targetPointId, setTargetPointId] = useState<string>()
	
	const [points, setPoints] = useState<IWayPointCreationWithCorrectionsSingleVoyage[]>(initialPoints || [])
	
	const [positions, setPositions] = useState<IPositionSingleVoyage[]>(initialPositions ?? [])
	const [activePointHelperIndicator, setActivePointHelperIndicator] = useState<boolean>(false)
	const [routeInfo, setRouteInfo] = useState<IRouteInfoMutateSingleVoyage>(() => getInitialRouteInfoMutateSingleVoyage({
		initialRouteInfo,
		initialPoints
	}))

	const prevAccountIdRef = useRef<string>(accountId)

	useEffect(() => {
		if (prevAccountIdRef.current === accountId) {
			return
		}
		prevAccountIdRef.current = accountId
		if (voyageId) {
			return
		}
		setRouteInfo((prev) => {
			return {
				...prev,
				deviceId: 0,
				driverId: null,
			}
		})
	}, [accountId])

	const [tasks, setTasks] = useState<ITaskCreationSingleVoyageMutateVoyage[]>(initialTasks ?? [])
	const [tasksLocalCreateIds, setTasksLocalCreateIds] = useState<number[]>(initialTasksLocalCreateIds || [])
	const [tasksLocalDeleteIds, setTasksLocalDeleteIds] = useState<number[]>([])
	
	
	
	return (
		<MutateVoyageRootContext.Provider
			value={{
				showAddPointIcon,
				setShowAddPointIcon,
				targetPointId,
				setTargetPointId,
				points,
				setPoints,
				positions,
				setPositions,
				activePointHelperIndicator,
				setActivePointHelperIndicator,
				routeInfo,
				setRouteInfo,
				voyageId,
				tasks,
				setTasks,
				tasksLocalCreateIds,
				setTasksLocalCreateIds,
				tasksLocalDeleteIds,
				setTasksLocalDeleteIds,
				accountId,
			}}
		>
			{children}
		</MutateVoyageRootContext.Provider>
	);
};

export default RootContextProviderMutateSingleVoyage;
